import React from 'react';
import { tierBackgroundStyle, tierCrownStyle, tierParentOpacityStyle, tierParentStyle } from '../../style.vs.css';
import type { LoyaltyTierIconProps } from '../..';

export const SilverMD = ({ behavior }: Pick<LoyaltyTierIconProps, 'behavior'>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        className={behavior === 'changeOpacityOnHover' ? tierParentOpacityStyle : tierParentStyle}
    >
        <path
            d="M10.7727 0.708566C11.5322 0.270104 12.4678 0.270104 13.2273 0.708566L21.165 5.29143C21.9245 5.7299 22.3923 6.54021 22.3923 7.41713V16.5829C22.3923 17.4598 21.9245 18.2701 21.165 18.7086L13.2273 23.2914C12.4678 23.7299 11.5322 23.7299 10.7727 23.2914L2.83497 18.7086C2.07553 18.2701 1.6077 17.4598 1.6077 16.5829V7.41713C1.6077 6.54021 2.07553 5.7299 2.83497 5.29143L10.7727 0.708566Z"
            fill="url(#paint0_linear_1934_137582)"
            {...(behavior === 'showColorOnHover' ? { className: tierBackgroundStyle } : {})}
        />
        <path
            d="M15.9106 9.88447C15.9457 9.61275 15.6458 9.42515 15.4168 9.57561L14.096 10.4436C14.0408 10.4798 13.9674 10.4703 13.9233 10.4212L12.2385 8.54384C12.1112 8.40194 11.8888 8.40194 11.7615 8.54384L10.0767 10.4212C10.0326 10.4703 9.9592 10.4798 9.90401 10.4436L8.5832 9.57561C8.35424 9.42515 8.05429 9.61275 8.08938 9.88447L8.65564 14.2694C8.67284 14.4026 8.78623 14.5023 8.9205 14.5023H15.0795C15.2138 14.5023 15.3272 14.4026 15.3444 14.2694L15.9106 9.88447Z"
            fill="url(#paint1_linear_1934_137582)"
            {...(behavior === 'showColorOnHover' ? { className: tierCrownStyle } : {})}
        />
        <defs>
            <linearGradient
                id="paint0_linear_1934_137582"
                x1="12"
                y1="0"
                x2="12"
                y2="24"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#D6E1EA" />
                <stop offset="1" stopColor="#8795A0" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_1934_137582"
                x1="12"
                y1="8.27808"
                x2="12"
                y2="14.5023"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FBFBFB" />
                <stop offset="1" stopColor="#CCD4DA" />
            </linearGradient>
        </defs>
    </svg>
);
